import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
  const allSLiders = document.querySelectorAll('.content-image-slider');

  allSLiders.forEach((slider) => {
    const generatedSlider = new Splide(slider, {
      perPage: 1,
      pagination: false,
      arrows: true,
    })

    generatedSlider.mount();

    const currentField = slider.querySelector('.image-slider__current');
    const total = slider.querySelector('.image-slider__total');
    const arrows = slider.querySelectorAll('.image-slider__arrow');

    const initCounter = () => {
      currentField.textContent = generatedSlider.index + 1;
      total.textContent = generatedSlider.length;
    }

    initCounter();
    arrows.forEach(item => {
      item.addEventListener('click', initCounter);
    })
  })

});